import React, { createContext, useState, useEffect } from "react";
import { toAbsoluteUrl } from "./AssetHelpers";
import { useAuth } from "../../app/modules/auth";

type UserType = {
  profile_image: string;
};

type PropsUserContext = {
  profileImageState: UserType;
  setState: React.Dispatch<React.SetStateAction<UserType>>;
  setProfileImage: (imageUrl: string) => void;
};

const DEFAULT_VALUE: PropsUserContext = {
  profileImageState: {
    profile_image: toAbsoluteUrl("/media/avatars/blank.png"),
  },
  setState: () => {},
  setProfileImage: () => {},
};

const ProfileImageContext = createContext<PropsUserContext>(DEFAULT_VALUE);

interface ProfileImageProviderProps {
  children: React.ReactNode;
}

const ProfileImageProvider: React.FC<ProfileImageProviderProps> = ({
  children,
}) => {
  const { currentUser } = useAuth();
  const [profileImageState, setState] = useState<UserType>(
    DEFAULT_VALUE.profileImageState
  );

  useEffect(() => {
    if (currentUser?.profile_image) {
      // const pathUrl = process.env.AWS_S3_BUCKET_URL;
      const pathUrl = "https://admin.aacceson.com/";
      const imageUrl = `${pathUrl}${currentUser.profile_image}`;

      setState((prev: any) => ({
        ...prev,
        profile_image: imageUrl,
      }));
    }
  }, [currentUser]);

  const setProfileImage = (imageUrl: string) => {
    const pathUrl = "https://admin.aacceson.com/";
    const fullUrl = `${pathUrl}${imageUrl}`;

    setState((prev) => ({ ...prev, profile_image: fullUrl }));
  };

  return (
    <ProfileImageContext.Provider
      value={{ profileImageState, setState, setProfileImage }}
    >
      {children}
    </ProfileImageContext.Provider>
  );
};

export { ProfileImageProvider, ProfileImageContext };
